import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import Breadcrumbs from "../based/Breadcrumbs";
import Common from "../based/Common";
import CommonTable from "../based/CommonTable";
import { ARTWORK_TYPE, INITPAGING, NOTIFY } from "../based/Constants";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import BaseServices from "../based/services/BaseServices";
import { Layout } from "../layout/Layout";
import Back from "./assets/Back.mp3";
import Back2Side from "./assets/Back2Side.mp3";
import ChangeArtwork from "./assets/ChangeArtwork.mp3";
import Fail from "./assets/Fail.mp3";
import Front from "./assets/Front.mp3";
import Front2Side from "./assets/Front2Side.mp3";
import Rescan from "./assets/Rescan.mp3";
import ScanProduct from "./assets/ScanProduct.mp3";
import Sucess from "./assets/Sucess.mp3";
import NotFound from "./assets/NotFound.mp3";
import PetErrorModal from "./PetErrorModal";
import { PartnerLogoPosition } from "../manage-partner/PartnerLogo";

const INIT_DATA = {
    size: "",
    productName: "",
    colorCode: "",
    orderId: 0,
    productId: 0,
    printedStatus: false,
    operatorOrderId: 0,
    orderDate: null,
    totalPrintPet: 0,
    countPrintedPet: 0,
    printingBatchs: [],
    barcodes: [],
    sellerSKU: "",
};
const PetManagementDesktop = () => {
    const [data, setData] = useState({ ...INIT_DATA });
    const [product, setProduct] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING });
    const [isBusy, setBusy] = useState(false);
    const tableRef = useRef(null);
    const inputRef = useRef(null);
    const [code, setCode] = useState("");
    const [isAction, setIsAction] = useState(false);
    const [isModalError, setIsModalError] = useState(false);
    const [changeOperatorOrderId, setChangeOperatorOrderId] = useState(0);

    var audio;
    const playSound = (soundUrl) => {
        return new Promise((resolve, reject) => {
            audio = new Audio(soundUrl);
            audio.play();
            audio.onended = () => {
                resolve(true);
            };
        });
    };
    useEffect(() => {
        if (!isModalError) {
            inputRef.current?.focus();
        }
    }, [isModalError]);

    const handleGetProduct = async (code) => {
        if (!code) return;

        setBusy(true);
        const [err, dt] = await BaseServices.Get(`/api/PetPressed/get-pet-by-code/${code}`);
        if (!err) {
            //quét mã sản xuất/tag id
            if (dt) {
                //quét để thay đổi arwork
                if (data.operatorOrderId && data.sellerSKU && data.operatorOrderId != dt.operatorOrderId) {
                    if (dt.operatorOrderId == changeOperatorOrderId) {
                        setData(dt);
                        setProduct(dt.products);
                        setIsAction(false);
                        window.scrollTo(0, 0);
                        Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Đổi arkwork thành công");
                        await playSound(ChangeArtwork);

                        var soundSide = ScanProduct;
                        if (code.length == 6) {
                            //kiểm tra 1 mặt hay 2 mặt
                            let isDoubleSide = dt.barcodes && dt.barcodes.length == 2;
                            let isFront = dt.barcodes && dt.barcodes.find((x) => x.barcode == code && x.artworkType == ARTWORK_TYPE.Front);
                            //2 mặt
                            if (isDoubleSide) {
                                if (isFront) {
                                    soundSide = Front2Side;
                                } else {
                                    soundSide = Back2Side;
                                }
                            } else {
                                if (isFront) {
                                    soundSide = Front;
                                } else {
                                    soundSide = Back;
                                }
                            }
                        }
                        await playSound(soundSide);
                    } else {
                        setChangeOperatorOrderId(dt.operatorOrderId);
                        Notify(NOTIFY.WARNING, "Yêu cầu đổi arkwork", "Quét lại lần 2 để thay đổi artrwork");
                        await playSound(Rescan);
                    }
                }
                //quét lần đầu tiên
                else {
                    setData(dt);
                    setProduct(dt.products);
                    setIsAction(false);
                    window.scrollTo(0, 0);

                    var soundSide = ScanProduct;
                    if (code.length == 6) {
                        //kiểm tra 1 mặt hay 2 mặt
                        let isDoubleSide = dt.barcodes && dt.barcodes.length == 2;
                        let isFront = dt.barcodes && dt.barcodes.find((x) => x.barcode == code && x.artworkType == ARTWORK_TYPE.Front);
                        //2 mặt
                        if (isDoubleSide) {
                            if (isFront) {
                                soundSide = Front2Side;
                            } else {
                                soundSide = Back2Side;
                            }
                        } else {
                            if (isFront) {
                                soundSide = Front;
                            } else {
                                soundSide = Back;
                            }
                        }
                    }
                    await playSound(soundSide);
                }
            }
            //quét mã sản phẩm (sku sản phẩm)
            else {
                //check sku
                if (data.operatorOrderId && data.sellerSKU && !data.printedStatus) {
                    //bỏ số lô của tem áo
                    let sku = code.substring(0, code.length - 1);
                    if (data.sellerSKU && data.sellerSKU === sku) {
                        setIsAction(true);
                        var sound = data.soundUrl ?? Sucess;
                        await playSound(sound);
                    } else {
                        setIsAction(false);
                        Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Sai áo");
                        await playSound(Fail);
                    }
                } else {
                    Notify(NOTIFY.WARNING, NOTIFY.WARNING, "Không tim thấy arkwork");
                    await playSound(NotFound);
                }
            }
        } else {
            setData({ ...INIT_DATA });
            setProduct([]);
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lỗi api");
        }
        setBusy(false);
    };

    const handlePressSuccess = async (operatorOrderId) => {
        if (operatorOrderId > 0) {
            setBusy(true);
            const [err, data] = await BaseServices.Get(`/api/PetPressed/change-status/${operatorOrderId}`);
            if (!err && data) {
                handleGetProduct(operatorOrderId);
                Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Thành công");
            } else {
                Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Thất bại");
            }
            setBusy(false);
        }
    };

    const handleError = async () => {
        if (data.operatorOrderId > 0) {
            setIsModalError(true);
        }
    };

    const _renderAction = () => {
        return <h6 className="mb-2">Danh sách đã ép</h6>;
    };

    const _renderBody = () => {
        return (
            <tbody>
                {product &&
                    product.length > 0 &&
                    product.map((item, idx) => {
                        return (
                            <tr key={idx} className={`${item.printedStatus ? "success" : "error"}`}>
                                <td>{item.printDate && Common.formatDate(new Date(item.printDate), "datetime")}</td>
                                <td>
                                    {item.barcodes.length > 0 &&
                                        item.barcodes.map((item, i) => {
                                            return <div key={i}>{item.barcode}</div>;
                                        })}
                                </td>
                                <td>{item.orderId}</td>
                                <td>{item.productName}</td>
                                <td>{item.size}</td>
                                <td>
                                    <div style={{ width: "100%", height: 40, background: data.colorCode }}></div>
                                </td>
                                <td>{item.productId}</td>
                                <td>{item.operatorOrderId}</td>
                                <td>{Common.formatDate(new Date(item.orderDate), "datetime")}</td>
                                <td className="status">{item.printedStatus ? "Đã xong" : "Chưa xong"}</td>
                                <td style={{ textAlign: "center" }}>
                                    <button
                                        className="btn btn-custom"
                                        onClick={async () => {
                                            setCode(item.operatorOrderId);
                                            handleGetProduct(item.operatorOrderId);
                                        }}
                                    >
                                        Chi tiết
                                    </button>
                                </td>
                            </tr>
                        );
                    })}
            </tbody>
        );
    };

    const _renderHeader = () => {
        return (
            <thead>
                <tr className="text-center">
                    <th>Thời gian ép</th>
                    <th>Mã SX</th>
                    <th>Mã đơn hàng</th>
                    <th>Dòng sản phẩm</th>
                    <th>Size</th>
                    <th>Màu</th>
                    <th>Mã SP</th>
                    <th>Tag ID</th>
                    <th>Ngày đặt</th>
                    <th>Trạng thái</th>
                    <th></th>
                </tr>
            </thead>
        );
    };

    return (
        <Layout>
            <StylePet>
                {isModalError && (
                    <PetErrorModal
                        operatorOrderId={data.operatorOrderId}
                        onClose={() => {
                            setIsModalError(false);
                        }}
                    />
                )}
                <Loading show={isBusy} />
                <Breadcrumbs currentPage="Quản lý xử lý ép PET (DTF)" />
                <div className="box-flex">
                    <div className="box-item w-25 mh">
                        <div className="item">
                            <div className={`box-input ${isBusy ? "disabled" : ""}`}>
                                <input
                                    type="text"
                                    placeholder="Mã sản xuất"
                                    value={code}
                                    ref={inputRef}
                                    onBlur={(e) => {
                                        if (!isModalError) {
                                            setTimeout(() => {
                                                inputRef.current?.focus();
                                            }, 2000);
                                        }
                                    }}
                                    autoFocus
                                    onKeyPress={(e) => {
                                        if (e.charCode == 13) {
                                            setCode("");
                                            handleGetProduct(code);
                                        }
                                    }}
                                    onChange={(e) => {
                                        setCode(e.target.value);

                                        if (e.target.value == "RESET") {
                                            setData({ ...INIT_DATA });
                                            setProduct([]);
                                            setCode("");
                                            setIsAction(false);
                                        }

                                        if (e.target.value && e.target.value.length == 6) {
                                            setCode("");
                                            handleGetProduct(e.target.value);
                                        }
                                    }}
                                />
                                <button
                                    className="btn btn-custom"
                                    onClick={() => {
                                        setCode("");
                                        handleGetProduct(code);
                                    }}
                                >
                                    Nhập
                                </button>
                                <button
                                    className="btn btn-secondary ml-3"
                                    onClick={(e) => {
                                        setData({ ...INIT_DATA });
                                        setProduct([]);
                                        setCode("");
                                        setIsAction(false);
                                        inputRef.current?.focus();
                                    }}
                                >
                                    RESET
                                </button>
                            </div>
                            <div className={`box-flex box-custom ${data.operatorOrderId ? (isAction || data.printedStatus ? "success" : "error") : ""}`}>
                                <div className={`w-50`}>
                                    <span>Sản phẩm phôi</span>
                                    <strong>{data.productName}</strong>
                                </div>
                                <div className="w-50">
                                    <span>Màu</span>
                                    <div className="color" style={{ background: data.colorCode }}></div>
                                </div>
                            </div>
                            <div className={`box-flex box-custom ${data.operatorOrderId ? (isAction || data.printedStatus ? "success" : "error") : ""}`}>
                                <div className="w-50">
                                    <span>Size</span>
                                    <strong className="size">{data.size}</strong>
                                </div>

                                <div className="w-50">
                                    <span>Mã sản phẩm</span>
                                    <strong className="name">{data.sellerSKU}</strong>
                                </div>
                            </div>
                            <div className="box-info">
                                <div>
                                    <strong>Mã đơn hàng</strong>
                                    <span>{data.platformOrderNumber}</span>
                                </div>
                                <div>
                                    <strong>Tag ID</strong>
                                    <span>{data.operatorOrderId > 0 && data.operatorOrderId}</span>
                                </div>
                                <div>
                                    <strong>Batch SX</strong>
                                    <span>
                                        {data.printingBatchs.length > 0 &&
                                            data.printingBatchs.map((item, i) => {
                                                return `B${item}`;
                                            })}
                                    </span>
                                </div>
                                <div>
                                    <strong>Ngày đặt hàng</strong>
                                    <span>{data.orderDate && Common.formatDate(new Date(data.orderDate), "datetime")}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-item w-75 box-flex">
                        {data.barcodes.length > 0 &&
                            data.barcodes.map((item, idx) => {
                                return (
                                    <div key={idx} className="box-item w-33 mb">
                                        <div className="item">
                                            <div className="title">
                                                {item.artworkType == 1 && "Mặt trước"}
                                                {item.artworkType == 2 && "Mặt sau"}
                                            </div>
                                            <div className="box-img">
                                                <img src={item.productImageUrl} />
                                            </div>
                                            <div>
                                                <span className="title">Mã sản xuất: </span>
                                                <span className="code">{item.barcode}</span>
                                            </div>
                                            <div className="box-flex box-size">
                                                <div className="box-size-item">
                                                    <span>Kích thước</span>
                                                    <strong>
                                                        {item.width}x{item.height}cm
                                                    </strong>
                                                </div>
                                                <div className="box-size-item">
                                                    <span>Top - Cổ</span>
                                                    <strong>{item.collarToImage}cm</strong>
                                                </div>
                                                <div className="box-size-item">
                                                    <span>Giữa - Trái</span>
                                                    <strong>{item.leftToMid}cm</strong>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        {data.partnerLogoModel && (
                            <div className="box-item w-33 mb">
                                <div className="item">
                                    <div className="title">Logo Brand</div>
                                    <div className="box-img">
                                        <img src={data.partnerLogoModel.thumbnail} />
                                    </div>
                                    <div>
                                        <span className="title"></span>
                                        <span className="code"></span>
                                    </div>
                                    {data.partnerLogoModel.position == PartnerLogoPosition.Bottom && (
                                        <div className="box-flex box-size">
                                            <div className="box-size-item logo-partner">
                                                <div className="box-size-item-left">{<img src={data.partnerLogoModel.logo} alt="" className="" />}</div>
                                                <div className="box-size-item-right">
                                                    <div className="right-top">Đáy áo</div>
                                                    <div className="right-bottom">
                                                        {data.partnerLogoModel.width}x{data.partnerLogoModel.height}cm
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="box-size-item">
                                                <span>Đáy</span>
                                                <strong>{data.partnerLogoModel.firstRange}cm</strong>
                                            </div>
                                            <div className="box-size-item">
                                                <span>Phải</span>
                                                <strong>{data.partnerLogoModel.secondRange}cm</strong>
                                            </div>
                                        </div>
                                    )}
                                    {data.partnerLogoModel.position == PartnerLogoPosition.LeftSleeve && (
                                        <div className="box-flex box-size">
                                            <div className="box-size-item logo-partner">
                                                <div className="box-size-item-left">{<img src={data.partnerLogoModel.logo} alt="" className="" />}</div>
                                                <div className="box-size-item-right">
                                                    <div className="right-top">Tay trái</div>
                                                    <div className="right-bottom">
                                                        {data.partnerLogoModel.width}x{data.partnerLogoModel.height}cm
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="box-size-item">
                                                <span>Cách đáy tay</span>
                                                <strong>{data.partnerLogoModel.firstRange}cm</strong>
                                            </div>
                                        </div>
                                    )}
                                    {data.partnerLogoModel.position == PartnerLogoPosition.Chest && (
                                        <div className="box-flex box-size">
                                            <div className="box-size-item logo-partner">
                                                <div className="box-size-item-left">{<img src={data.partnerLogoModel.logo} alt="" className="" />}</div>
                                                <div className="box-size-item-right">
                                                    <div className="right-top">Ngực</div>
                                                    <div className="right-bottom">
                                                        {data.partnerLogoModel.width}x{data.partnerLogoModel.height}cm
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="box-size-item">
                                                <span>Cách cổ</span>
                                                <strong>{data.partnerLogoModel.firstRange}cm</strong>
                                            </div>
                                            <div className="box-size-item">
                                                <span>Cách tâm</span>
                                                <strong>{data.partnerLogoModel.secondRange}cm</strong>
                                            </div>
                                        </div>
                                    )}
                                    {data.partnerLogoModel.position == PartnerLogoPosition.Back && (
                                        <div className="box-flex box-size">
                                            <div className="box-size-item logo-partner">
                                                <div className="box-size-item-left">{<img src={data.partnerLogoModel.logo} alt="" className="" />}</div>
                                                <div className="box-size-item-right">
                                                    <div className="right-top">Lưng</div>
                                                    <div className="right-bottom">
                                                        {data.partnerLogoModel.width}x{data.partnerLogoModel.height}cm
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="box-size-item">
                                                <span>Cách cổ</span>
                                                <strong>{data.partnerLogoModel.firstRange}cm</strong>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="table mt-3">
                    <CommonTable data={data} paging={paging} hideSearchBasicButton renderAction={_renderAction} renderHeader={_renderHeader} renderBody={_renderBody} ref={tableRef} />
                </div>
            </StylePet>
        </Layout>
    );
};
const StylePet = styled.div`
    .box-size-item {
        display: flex;
    }

    .box-flex.box-size {
        height: 80px;
    }

    .box-size-item-left {
        width: 50%;
        height: 100%;
    }

    .box-size-item-left img {
        width: 70px;
        height: auto;
        object-fit: contain;
    }

    .box-size-item-left {
        display: flex;
        align-items: center;
    }
    .box-size-item {
        justify-content: center;
    }

    .box-size-item {
    }

    .box-size-item-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .box-size-item.logo-partner {
        flex-direction: row;
        padding: 0;
    }

    .right-top {
        color: #444;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        border: 1px solid #d9d9d9;
        padding: 5px;
        display: flex;
        align-items: center;
    }

    .right-bottom {
        color: #444;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        border: 1px solid #d9d9d9;
        padding: 5px;
        flex: 1;
        display: flex;
        align-items: center;
    }

    .box-size-item.logo-partner .box-size-item-left {
        padding: 5px;
        border: 1px solid #d9d9d9;
    }

    .box-size-item {
        border: 1px solid #d9d9d9;
        background: #fff;
        display: flex;
        flex-direction: column;
        padding: 8px;
    }

    .box-size-item span {
        color: #817979;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    .box-size-item strong {
        color: #444;
        font-family: Roboto;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 12px;
    }

    .table {
        tr {
            &.success {
                background-color: #dfffe0;

                td {
                    &.status {
                        color: #28b259;
                    }
                }
            }
            &.error {
                background-color: #ffdfdf;

                td {
                    &.status {
                        color: #f96a74;
                    }
                }
            }
        }
    }
    .box-flex {
        width: 100%;
        display: flex;
        align-items: stretch;
        flex-wrap: wrap;

        .box-custom {
            &.error {
                background-color: #ffdfdf;

                strong {
                    color: #f96a74 !important;
                }
            }

            &.success {
                background-color: #dfffe0;

                strong {
                    color: #64c5b1 !important;
                }
            }
        }

        .box-item {
            width: 25%;
            min-width: 25%;
            max-width: 25%;
            padding: 0 8px;

            &.mb {
                margin-bottom: 5px;
            }

            &.w-35 {
                width: 35%;
                min-width: 35%;
                max-width: 35%;
            }

            &.w-33 {
                width: 33.33333%;
                min-width: 33.33333%;
                max-width: 33.33333%;
            }

            &.w-65 {
                width: 65%;
                min-width: 65%;
                max-width: 65%;
            }

            &.w-75 {
                width: 75%;
                min-width: 75%;
                max-width: 75%;
            }

            &.w-50 {
                width: 50%;
                min-width: 50%;
                max-width: 50%;
            }

            .item {
                width: 100%;
                padding: 12px;
                background: #fff;
                height: 100%;
                position: relative;
                margin-bottom: 5px;

                .box-input {
                    display: flex;
                    margin-bottom: 12px;

                    input {
                        width: 65%;
                        height: 38px;

                        ::placeholder {
                            color: #444;
                            font-size: 14px;
                            font-weight: 500;
                            opacity: 0.2;
                        }
                    }
                    button {
                        width: 35% !important;
                        height: 38px;
                    }
                }

                .box-name {
                    border: 1px solid #ccc;
                    display: flex;
                    flex-direction: column;
                    padding: 6px;
                    strong {
                        margin-top: 8px;
                        color: #444;
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 1.2;
                    }
                }

                .box-info {
                    display: grid;
                    grid-template-columns: 50% 50%;
                    grid-template-rows: auto auto;
                }

                .box-flex.box-custom .w-50 {
                    border: 1px solid #d9d9d9;
                    padding: 10px;
                    display: flex;
                    flex-direction: column;
                }

                .box-flex.box-custom .w-50 span {
                    color: #817979;
                    font-family: Roboto;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;
                    margin-bottom: 12px;
                }

                .box-flex .box-custom.error strong {
                    font-size: 18px;
                    font-weight: 700;
                }

                .color {
                    width: 100%;
                    height: 30px;
                }

                strong.size {
                    font-size: 40px !important;
                }

                strong.name {
                    flex: 1;
                    align-items: center;
                    display: flex;
                }
                .box-info {
                    margin-top: 18px;
                    border: 1px solid #ccc;

                    div {
                        display: flex;
                        flex-direction: column;
                        border: 1px solid #d9d9d9;
                        padding: 12px;
                        strong {
                            font-family: Roboto;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: normal;
                            margin-bottom: 7px;
                        }
                        span {
                            color: #444;
                            font-family: Roboto;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 600;
                            line-height: normal;
                        }
                    }
                }
                .box-statictis {
                    display: flex;
                    border: 1px solid #ccc;
                    align-items: center;
                    height: 39px;
                    padding: 6px;
                    span {
                        display: block;
                        margin-right: 8px;
                    }

                    strong {
                        font-size: 20px;
                        font-weight: 700;
                        line-height: 1;
                    }

                    &.error {
                        background-color: #ffdfdf;
                        span {
                            color: #f96a74;
                        }
                        strong {
                            color: #f96a74;
                        }
                    }

                    &.success {
                        background-color: #dfffe0;
                        span {
                            color: #64c5b1;
                        }
                        strong {
                            color: #64c5b1;
                        }
                    }
                }

                .title {
                    color: #444;
                    font-size: 16px;
                    font-weight: 700;
                    line-height: 1;
                }

                .code {
                    margin-left: 8px;
                    color: #444;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 1;
                }

                .box-img {
                    width: 100%;
                    text-align: center;
                    margin: 6px auto;

                    img {
                        width: 95%;
                        aspect-ratio: 1/1;
                        object-fit: contain;
                    }
                }

                .w-33 {
                    width: 33.33333%;
                    min-width: 33.33333%;
                    max-width: 33.33333%;
                    border: 1px solid #ccc;
                    padding: 8px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    height: 65px;

                    span {
                        line-height: 1;
                        color: #817979;
                        font-size: 14px;
                        font-weight: 400;
                        white-space: nowrap;
                    }

                    .size {
                        color: #444;
                        font-size: 40px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 1;
                    }

                    .name {
                        color: #444;
                        font-size: 14px;
                        font-weight: 700;
                        line-height: 1;
                    }

                    .color {
                        width: 100%;
                        height: 20px;
                    }

                    strong {
                        color: #444;
                        font-size: 20px;
                        font-weight: 700;
                        line-height: 1;
                    }
                }

                .box-button {
                    width: 100%;
                    margin-top: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    button {
                        width: 45% !important;
                    }
                }
            }
        }
    }
`;
export default PetManagementDesktop;
